import "../../css/Months.css";
import Monthly from "./Monthly";
import { useState } from "react";

export default function Months() {
  const [month, setMonth] = useState("june");

  return (
    <div>
      <div class="container">
        <p></p>

        <div class="col-lg-12 mb-4">
          <h4 class="mb-4">Επιλέξτε Μήνα</h4>
          <button
            onClick={() => setMonth("january")}
            class="btn btn-primary btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-check"></i>1
          </button>
          <button
            onClick={() => setMonth("february")}
            class="btn btn-primary btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-cog"></i>2
          </button>
          <button
            onClick={() => setMonth("march")}
            class="btn btn-primary btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-paper-plane"></i>3
          </button>
          <button
            onClick={() => setMonth("april")}
            class="btn btn-info btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-tags"></i>4
          </button>
          <button
            onClick={() => setMonth("may")}
            class="btn btn-warning btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-sliders"></i>5
          </button>
          <button
            onClick={() => setMonth("june")}
            class="btn btn-warning btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-search"></i>6
          </button>
          <button
            onClick={() => setMonth("july")}
            class="btn btn-danger btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-wrench"></i>7
          </button>
          <button
            onClick={() => setMonth("august")}
            class="btn btn-danger btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-bar-chart"></i>8
          </button>
          <button
            onClick={() => setMonth("september")}
            class="btn btn-warning btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-sliders"></i>9
          </button>
          <button
            onClick={() => setMonth("october")}
            class="btn btn-info btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-search"></i>10
          </button>
          <button
            onClick={() => setMonth("november")}
            class="btn btn-info btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-wrench"></i>11
          </button>
          <button
            onClick={() => setMonth("december")}
            class="btn btn-primary btn-circle btn-circle-lg m-1"
          >
            <i class="fa fa-bar-chart"></i>12
          </button>
        </div>

        <Monthly month={month}> </Monthly>
      </div>
    </div>
  );
}
